(function () {
  'use strict';

  function esc(value) {
    return (value == null ? '' : String(value)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function withWidth(url, width) {
    if (!url) return '';
    if (!width) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function srcsetFor(url, widths) {
    return widths.map(function (w) { return esc(withWidth(url, w)) + ' ' + w + 'w'; }).join(', ');
  }

  function stripHtml(text) {
    return String(text == null ? '' : text).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function truncateWords(text, limit) {
    var words = stripHtml(text).split(' ').filter(Boolean);
    if (!words.length) return '';
    if (words.length <= limit) return words.join(' ');
    return words.slice(0, limit).join(' ') + '...';
  }

  var ARROW_SVG =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M13.5 19.5L21 12L13.5 4.5M21 12H3" stroke="#F5F3ED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function getConfig(root) {
    var featuredWords = parseInt(root.getAttribute('data-sbca-featured-words'), 10);
    var cardWords = parseInt(root.getAttribute('data-sbca-card-words'), 10);
    return {
      shop: root.getAttribute('data-sbca-shop'),
      version: root.getAttribute('data-sbca-version') || '2024-10',
      token: root.getAttribute('data-sbca-token') || window.SF_API_TOKEN,
      blogHandle: root.getAttribute('data-sbca-blog-handle') || '',
      blogTitle: root.getAttribute('data-sbca-blog-title') || '',
      featuredBtn: root.getAttribute('data-sbca-featured-btn') || 'Read More',
      showArrow: root.getAttribute('data-sbca-show-arrow') === 'true',
      cardBtn: root.getAttribute('data-sbca-card-btn') || 'Read More',
      featuredWords: Number.isInteger(featuredWords) && featuredWords > 0 ? featuredWords : 28,
      cardWords: Number.isInteger(cardWords) && cardWords > 0 ? cardWords : 19,
      empty: root.getAttribute('data-sbca-empty') || 'No articles found with tag',
      hideWithoutImage: root.getAttribute('data-sbca-hide-without-image') === 'true',
      designMode: root.getAttribute('data-sbca-design-mode') === 'true',
    };
  }

  function hasArticleImage(node) {
    return !!(node && node.image && node.image.url);
  }

  var ARTICLES_QUERY =
    'query SbcaArticles($q: String!, $n: Int!) {' +
    '  articles(first: $n, sortKey: PUBLISHED_AT, reverse: true, query: $q) {' +
    '    edges { node {' +
    '      title handle onlineStoreUrl' +
    '      excerpt content(truncateAt: 600)' +
    '      image { url altText }' +
    '    } }' +
    '  }' +
    '}';

  function buildSearchQuery(blogTitle, tag) {
    var parts = [];
    if (blogTitle) parts.push("blog_title:'" + blogTitle.replace(/(['\\])/g, '\\$1') + "'");
    if (tag) parts.push("tag:'" + tag.replace(/(['\\])/g, '\\$1') + "'");
    return parts.join(' AND ');
  }

  function sfRequest(config, query, variables) {
    if (window.StorefrontClient && typeof window.StorefrontClient.request === 'function') {
      return window.StorefrontClient.request(query, variables);
    }
    if (!config.shop || !config.token) return Promise.resolve(null);
    var endpoint = 'https://' + config.shop + '/api/' + config.version + '/graphql.json';
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': config.token },
      body: JSON.stringify({ query: query, variables: variables }),
    })
      .then(function (res) { return res.json(); })
      .catch(function () { return null; });
  }

  function fetchRow(config, tag) {
    var fetchLimit = config.hideWithoutImage ? 15 : 5;
    return sfRequest(config, ARTICLES_QUERY, {
      q: buildSearchQuery(config.blogTitle, tag),
      n: fetchLimit,
    }).then(function (json) {
      var conn = json && json.data && json.data.articles;
      if (!conn) return null;
      var articles = (conn.edges || [])
        .map(function (edge) {
          return edge && edge.node;
        })
        .filter(Boolean);

      if (config.hideWithoutImage) {
        articles = articles.filter(hasArticleImage);
      }

      return articles.slice(0, 5);
    });
  }

  function articleUrl(node, config) {
    return node.onlineStoreUrl || '/blogs/' + config.blogHandle + '/' + node.handle;
  }

  function headingMarkup(heading, variant) {
    return (
      '<h2 class="sbca-heading sbca-heading--' + variant + '">' +
      '<span class="sbca-heading__dot" aria-hidden="true"></span>' +
      '<span class="sbca-heading__text">' + esc(heading) + '</span></h2>'
    );
  }

  function featuredMarkup(node, config) {
    var url = articleUrl(node, config);
    var media = node.image && node.image.url
      ? '<img class="sbca-featured__image" src="' + esc(withWidth(node.image.url, 1200)) + '"' +
        ' srcset="' + srcsetFor(node.image.url, [600, 800, 1000, 1200]) + '"' +
        ' sizes="(min-width: 1200px) 50vw, (min-width: 769px) 50vw, 100vw"' +
        ' loading="lazy" alt="' + esc(node.image.altText || node.title || '') + '">'
      : '<span class="sbca-featured__placeholder" aria-hidden="true"></span>';
    var excerpt = truncateWords(node.excerpt || node.content || '', config.featuredWords);

    return (
      '<article class="sbca-featured"><a href="' + esc(url) + '" class="sbca-featured__link">' +
      '<div class="sbca-featured__media">' + media +
      '<span class="sbca-featured__overlay" aria-hidden="true"></span></div>' +
      '<div class="sbca-featured__content">' +
      (node.title ? '<h3 class="sbca-featured__title">' + esc(node.title) + '</h3>' : '') +
      '<p class="sbca-featured__excerpt">' + esc(excerpt) + '</p>' +
      '<span class="sbca-featured__cta">' + esc(config.featuredBtn) + (config.showArrow ? ARROW_SVG : '') + '</span>' +
      '</div></a></article>'
    );
  }

  function cardMarkup(node, config) {
    var url = articleUrl(node, config);
    var thumb = node.image && node.image.url
      ? '<img class="sbca-card__image" src="' + esc(withWidth(node.image.url, 200)) + '"' +
        ' srcset="' + srcsetFor(node.image.url, [80, 120, 160, 200]) + '"' +
        ' sizes="80px" loading="lazy" alt="' + esc(node.image.altText || node.title || '') + '">'
      : '<span class="sbca-card__placeholder" aria-hidden="true"></span>';
    var excerpt = node.excerpt ? stripHtml(node.excerpt) : truncateWords(node.content || '', config.cardWords);

    return (
      '<article class="sbca-card">' +
      '<a href="' + esc(url) + '" class="sbca-card__thumb">' + thumb + '</a>' +
      '<div class="sbca-card__body">' +
      (node.title
        ? '<h3 class="sbca-card__title"><a href="' + esc(url) + '">' + esc(node.title) + '</a></h3>'
        : '') +
      '<p class="sbca-card__excerpt">' + esc(excerpt) + '</p>' +
      '<a href="' + esc(url) + '" class="sbca-card__button">' + esc(config.cardBtn) + '</a>' +
      '</div></article>'
    );
  }

  function rowMarkup(articles, heading, config) {
    var html = headingMarkup(heading, 'mobile');
    html += '<div class="sbca-layout">';
    html += featuredMarkup(articles[0], config);

    if (articles.length > 1) {
      html += '<div class="sbca-grid">';
      html += headingMarkup(heading, 'desktop');
      for (var i = 1; i < articles.length && i < 5; i++) {
        html += cardMarkup(articles[i], config);
      }
      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  function emptyMarkup(heading, tag, config) {
    return (
      headingMarkup(heading, 'mobile') +
      '<p class="sbca-empty">' + esc(config.empty) + ' "' + esc(tag) + '".</p>'
    );
  }

  function initRoot(root) {
    if (!root || root.dataset.sbcaBound === 'true') return;
    root.dataset.sbcaBound = 'true';

    var config = getConfig(root);
    var hasClient = !!(window.StorefrontClient && window.StorefrontClient.request);
    if (!hasClient && (!config.shop || !config.token)) return;

    root.querySelectorAll('[data-sbca-block]').forEach(function (block) {
      var tag = block.getAttribute('data-sbca-tag');
      var heading = block.getAttribute('data-sbca-heading') || tag;
      if (!tag) return;

      fetchRow(config, tag)
        .then(function (articles) {
          if (articles === null) return;

          if (!articles.length) {
            if (config.designMode) {
              block.hidden = false;
              block.innerHTML = emptyMarkup(heading, tag, config);
            } else {
              block.hidden = true;
            }
            return;
          }

          block.innerHTML = rowMarkup(articles, heading, config);
          block.hidden = false;
        })
        .catch(function () {
          /* keep server fallback */
        });
    });
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sbca-root]').forEach(initRoot);
    if (scope.matches && scope.matches('[data-sbca-root]')) initRoot(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (root) boot(root);
  });
})();
